export default "__VITE_ASSET__CcF3xJap__"